import axios from 'axios'

const state = {
	list: [],
};

const mutations = {
	SET_LIST: (state, list) => {
		state.list = list;
	},
}

const options = {
	headers: {
		'Accept': 'application/vnd.api+json',
		'Content-Type': 'application/vnd.api+json',
	}
};

const actions = {

	getClients(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL+'/clients', payload, options)
			.then((response) => {
				return response
			})
	},

    fetchAllClients(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL+'/clients/fetch/all')
			.then((response) => {
				return response
			})
	},

	fetchAllClientsWithSites(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL+'/clients/fetch/all_with_sites')
			.then((response) => {
				return response
			})
	},
	
	fetchAllClientsWithSitesAndContracts(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL+'/clients/fetch/all_with_sites_contracts')
			.then((response) => {
				return response
			})
	},

	getClientDetails(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/clients/' + payload)
			.then((response) => {
				return response
			})
	},
	
	getClientContacts(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/clients/' + payload.client_id + '/contacts', payload, options)
			.then((response) => {
				return response
			})
	},

    getClientInterventions(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/clients/' + payload.id + '/interventions', {
            page: payload.page,
            perPage: payload.perPage,
            search: payload.search
        }, options).then((response) => {
            return response
        })
    },

	getClientSitesContracts(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL+'/clients/' + payload.id + '/sites_contracts', payload, options)
			.then((response) => {
				return response
			})
	},

	updateClient(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL + '/clients/' + payload.id, payload, options)
			.then((response) => {
				return response
			})
	},

	updateClientNotes(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL + '/clients/notes/' + payload.id, payload, options)
			.then((response) => {
				return response
			})
	},

}

const getters = {
	list: state => state.list,
};

const clients = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};

export default clients;
